import "./App.css";
import { Route, Routes } from "react-router-dom";
import ProtectedRoutesOutlet from "./_routes/ProtectedRotuesOutlet";
import ProtectedRotues from "./_routes/ProtectedRoutes";
import toast, { Toaster, ToastBar } from "react-hot-toast";
import PublicRoutes from "./_routes/PublicRoutes";
import PublicRoutesOutlet from "./_routes/PublicRotuesOutlet";
import { useSelector } from "react-redux";
import TermsAndConditions from "./_pages/TermsAndConditions";
import AboutSalah from "./_pages/AboutSalah";

function App() {
  const lang = useSelector((state) => state.language.lang);
  return (
    <div
      style={{
        margin: "5rem 0",
        padding: "0 1rem",
        direction: lang == "ar" ? "rtl" : "ltr",
      }}
      className="w-100"
    >
      <Toaster position="top-right" containerClassName="hot-toaster-container">
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {t.type === "error" ? (
                  <button
                    type="button"
                    className="toast-dismiss-btn"
                    aria-label="Dismiss notification"
                    onClick={() => toast.dismiss(t.id)}
                  >
                    {icon}
                  </button>
                ) : (
                  icon
                )}
                {message}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>
      <Routes>
      <Route element={<PublicRoutesOutlet />}>
          {PublicRoutes?.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}
        </Route>
        <Route element={<ProtectedRoutesOutlet />}>
          {ProtectedRotues?.map((route,i) => (
            <Route key={i} path={route.path} element={route.element} />
          ))}
        </Route>

        <Route path='terms-and-conditions' element={<TermsAndConditions />} />
        <Route path='about-salah' element={<AboutSalah />} />
        
        <Route path="*" element={<p>404 Not Found!</p>} />
      </Routes>
    </div>
  );
}

export default App;
